"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var ContentLine_1 = require("../../../contentLine/ContentLine");
var Price_1 = require("../../../../../../common/components/prices/price/Price");
var cashSummaryBlockStyles_1 = require("./cashSummaryBlockStyles");
var Translation_1 = require("../../../../../../../common/components/presentation/Translation/Translation");
var PriceDisplayType_1 = require("../../../../../../../../../common/enum/PriceDisplayType");
var useTotalPrice_1 = require("../../../../../../common/hooks/prices/useTotalPrice");
var CashSummaryBlocks = function (_a) {
    var subtitle = _a.subtitle, prices = _a.prices, isMultiCurrency = _a.isMultiCurrency;
    var _b, _c;
    var style = cashSummaryBlockStyles_1.default();
    var totalFinalPrices = useTotalPrice_1.default(prices.totalPrice).totalFinalPrices;
    var primaryTotalPrice = totalFinalPrices[0], secondaryTotalPrice = totalFinalPrices[1];
    var priceContainer = react_1.useCallback(function (withSign) { return (<>
        {withSign}
        <Price_1.default className={style.price} price={primaryTotalPrice.money.amount} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={primaryTotalPrice.money.currency}/>
      </>); }, []);
    return (<core_1.Box className={style.cashSummaryBlocks} data-test="finance_summary:container:cash_summary_blocks">
      <ContentLine_1.default mainContent={<core_1.Typography variant="h4">
            <Translation_1.default id={'trans__checkout__confirmation_page__summary__cash_payment_title'} className={style.title}/>
          </core_1.Typography>}/>
      {subtitle && (<ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
              <Translation_1.default className={style.element} id={subtitle}/>
            </core_1.Typography>}/>)}
      <ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
            <Translation_1.default className={style.element} id={'trans__checkout__confirmation_page__summary__total_payment'} values={{
        total: (<>
                    {priceContainer()}
                    {isMultiCurrency && (<>
                        <core_1.Typography component="span" data-test="cash_price:divider" className={style.divider}>
                          <Translation_1.default className={style.element} id={'trans__checkout__vehicle_details__price_separator'}/>
                        </core_1.Typography>
                        <Price_1.default price={(_b = secondaryTotalPrice) === null || _b === void 0 ? void 0 : _b.money.amount} priceDisplayType={PriceDisplayType_1.PriceDisplayType.SECONDARY} currency={(_c = secondaryTotalPrice) === null || _c === void 0 ? void 0 : _c.money.currency}/>
                      </>)}
                  </>),
    }}/>
          </core_1.Typography>}/>
    </core_1.Box>);
};
exports.default = CashSummaryBlocks;
